// aboutus.js — About page (mockup-style layout; edit copy & media here)

const aboutUsData = {
  hero: {
    eyebrow: "Properties In Finite",
    title: "About Us",
    subtitle:
      "Discover the story behind India's trusted destination for premium properties—handpicked listings, nationwide reach, and guidance that makes every transaction seamless.",
    image:
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=2400&q=85",
  },

  /** Floating bar under hero (like search bar in reference UI) */
  heroBar: [
    { label: "Based in", value: "India" },
    { label: "Established", value: "2006" },
    { label: "Focus", value: "Premium Property" },
    { label: "Clients", value: "Pan-India" },
  ],

  sectionLabels: {
    one: "Heritage",
    two: "Growth & Excellence",
    three: "Experience Us",
  },

  tagline: "Two decades of curated listings, nationwide clients, and relationships built on trust.",

  story: {
    badge: "Since 2006",
    title: "A journey through time",
    body:
      "Two decades ago, Properties In Finite was founded with a singular vision—to make finding your perfect home in India effortless and transparent. From metropolitan apartments to sprawling villas, we partner with India's leading developers to connect buyers with properties that truly fit their life.",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
  },

  milestonesSection: {
    title: "Milestones that shaped us",
    lead: "Swipe or use arrows to explore how we grew across the Indian real estate market.",
  },

  milestones: [
    {
      year: "2006",
      title: "Our Foundation",
      desc: "Founded with a passion for connecting Indian families and investors with their ideal properties.",
      image:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=85",
    },
    {
      year: "2015",
      title: "Expansion & Partnerships",
      desc: "Forged alliances with top Indian developers and expanded our portfolio across major cities.",
      image:
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=85",
    },
    {
      year: "2026",
      title: "Excellence Today",
      desc: "800+ premium properties transacted and clients served across 10+ Indian states.",
      image:
        "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1200&q=85",
    },
  ],

  statsSection: {
    title: "Conveniences of our service",
    subtitle:
      "Everything you expect from a trusted Indian property firm—honest guidance, verified listings, and end-to-end support from site visit to registration.",
  },

  stats: [
    { id: 1, value: "20+", label: "Years of experience", icon: "trophy" },
    { id: 2, value: "500+", label: "Happy clients", icon: "smile" },
    { id: 3, value: "800+", label: "Properties transacted", icon: "home" },
    { id: 4, value: "10+", label: "States covered", icon: "map" },
  ],

  video: {
    title: "Our world in motion",
    caption: "See how we guide buyers and sellers across India's thriving property market.",
    playLabel: "Play film",
    thumbnail:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=85",
    embedUrl: "https://www.youtube.com/embed/YOUR_REAL_VIDEO_ID",
  },

  cta: {
    label: "Contact Us",
    path: "/contact",
    line: "Your dream home in India deserves a team that listens first—then delivers.",
  },
};

export default aboutUsData;